export default __webpack_public_path__ + "static/media/how-it-works-2.300b512f.png";